import React, {Component} from 'react';


class DraggableCell extends Component {
    constructor(props) {
        super(props);
        this.setRef = this.setRef.bind(this);
        this.ref;
    }

    getSnapshotBeforeUpdate(prevProps) {
        if (!this.ref) {
            return null;
        }

        const isDragStarting = this.props.isDragging && !prevProps.isDragging;

        if (!isDragStarting) {
            return null;
        }

        const {width, height} = this.ref.getBoundingClientRect();

        const snapshot = {width, height};
        return snapshot;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.ref) {
            return;
        }

        if (snapshot) {
            if (this.ref.style.width === snapshot.width) {
                return;
            }
            this.ref.style.width = `${snapshot.width}px`;
            this.ref.style.height = `${snapshot.height}px`;
            return;
        }

        if (this.props.isDragging) {
            return;
        }

        if (this.ref.style.width == null) {
            return;
        }
        // no snapshot and drag is finished - clear the inline styles
        this.ref.style.removeProperty('height');
        this.ref.style.removeProperty('width');
    }

    setRef(newRef) {
        this.ref = newRef;
    }

    render() {
        const {className, style, colSpan} = this.props;
        return <td ref={this.setRef} colSpan={colSpan} className={className} style={style}>{this.props.children}</td>;
    }
}

export default DraggableCell;
